import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import ReactSelect from '../ReactSelect';
import { getCountryOptions } from '../utils/countryOptions';

const ReactSelectCountries = ({ options, placeholder, ...props }) => (
  <ReactSelect
    options={isEmpty(options) ? getCountryOptions() : options}
    placeholder={placeholder || I18n.t('global.country')}
    {...props}
  />
);

ReactSelectCountries.propTypes = {
  placeholder: PropTypes.string,
  options: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

ReactSelectCountries.defaultProps = {
  options: [],
};

export default ReactSelectCountries;
